export default __webpack_public_path__ + "static/media/ecualizador.ac46b94e.jpg";